import { Box } from '@mui/material';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import EventNoteOutlined from '@mui/icons-material/EventNoteOutlined';
import { StatTile, type StatTileProps } from '../../components/StatTile';
import { useSummary } from './useSummary';

type Tile = StatTileProps & { to: string };

/** The four big numbers at the top of Home */
export function SummaryTiles() {
  const s = useSummary();
  const tiles: Tile[] = [
    {
      count: s.approvals,
      title: 'Approvals',
      note: 'Require your review',
      to: '/approvals',
      icon: <DescriptionOutlined />,
      tone: 'error',
    },
    {
      count: s.urgent,
      title: 'Urgent Issues',
      note: 'Need attention',
      to: '/shipments',
      icon: <ReportProblemOutlined />,
      tone: 'error',
    },
    {
      count: s.shipments,
      title: 'Active Shipments',
      note: 'In transit or pending',
      to: '/shipments',
      icon: <LocalShippingOutlined />,
      tone: 'info',
    },
    {
      count: s.reminders,
      title: 'Reminders',
      note: 'Due today',
      to: '/reminders',
      icon: <EventNoteOutlined />,
      tone: 'warning',
    },
  ];
  return (
    <Box
      sx={{
        display: 'grid',
        gap: { xs: 1.25, md: 2 },
        gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(4, minmax(0, 1fr))' },
      }}
    >
      {tiles.map((t) => (
        <StatTile key={t.title} {...t} />
      ))}
    </Box>
  );
}
